import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
// import _ from 'lodash'
import moment from 'moment'

import { Calendar, Tag, Modal } from 'antd'

// we could use FullCalendar if we need more functionality later
// https://fullcalendar.io/
class AppointmentsCalendar extends Component {
  state = {
    modalVisible: false,
    selectedAppointment: null
  }

  getCellData = value => {
    const { appointments } = this.props

    let cellData = []

    appointments.forEach(appointment => {
      const appointmentDate = appointment.data.appointmentDate
      const appointmentDayOfMonth = moment(appointmentDate).date()
      const appointmentMonth = moment(appointmentDate).month()

      if (appointmentDayOfMonth === value.date() && appointmentMonth === value.month()) {
        cellData.push(appointment)
      }
    })

    return cellData || []
  }

  showAppointmentDetail = appointment => {
    this.setState({
      modalVisible: true,
      selectedAppointment: appointment
    })
  }

  handleModal = () => {
    this.setState({
      modalVisible: !this.state.modalVisible
    })
  }

  dateCellRender = value => {
    const { contacts } = this.props

    const cellData = this.getCellData(value)

    return (
      <div>
        {cellData.map((appointment, index) => (
          <Tag
            color='#f50'
            key={index}
            style={{ width: '90%' }}
            onClick={() => this.showAppointmentDetail(appointment)}
          >
            {contacts[appointment.contactId].company}
          </Tag>
        ))}
      </div>
    )
  }
  renderAppointmentDetail = () => {
    const { contacts } = this.props
    const appointment = this.state.selectedAppointment

    return (
      <div>
        <h3>Meeting with {contacts[appointment.contactId].company}</h3>
        {moment(parseInt(appointment.data.appointmentDate, 10)).format('MMMM Do YYYY, HH:mm')}
      </div>
    )
  }

  render () {
    // const { t, match: { params }, contacts, projects, companies } = this.props

    // const currentProject = projects[params.projectId]

    // get Company Users - so we can use their names (users[userId]: { name_sync }) instead of IDs
    // const companyUsers = companies[currentProject.companyId].users

    return (
      <div>

        <Calendar dateCellRender={this.dateCellRender} />

        <Modal visible={this.state.modalVisible} onCancel={() => this.handleModal()} footer={null}>
          {this.state.selectedAppointment && this.renderAppointmentDetail()}
        </Modal>

      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  loading: state.loading,
  user: state.user,
  contacts: state.contacts,
  appointments: state.appointments,
  projects: state.projects,
  companies: state.companies
})

export default connect(mapStateToProps)(withRouter(translate('translations')(AppointmentsCalendar)))



// WEBPACK FOOTER //
// ./src/components/Appointments/AppointmentsCalendar.js